module.exports = __webpack_public_path__ + "img/hand.c134ec52.svg";